import React from 'react';
import { cn } from '../../../utils/cn';

interface CommentTabsProps {
  activeTab: 'active' | 'resolved';
  activeCount: number;
  resolvedCount: number;
  onTabChange: (tab: 'active' | 'resolved') => void;
}

export const CommentTabs: React.FC<CommentTabsProps> = ({
  activeTab,
  activeCount,
  resolvedCount,
  onTabChange,
}) => {
  return (
    <div className="flex py-3 gap-4">
      <button
        onClick={() => onTabChange('active')}
        className={cn(
          'text-sm font-medium relative',
          activeTab === 'active' ? 'text-gray-900' : 'text-gray-400'
        )}
      >
        {activeCount} Active
        {activeTab === 'active' && (
          <div className="absolute -bottom-3 left-0 right-0 h-[2px] bg-gray-900" />
        )}
      </button>
      <button
        onClick={() => onTabChange('resolved')}
        className={cn(
          'text-sm font-medium relative',
          activeTab === 'resolved' ? 'text-gray-900' : 'text-gray-400'
        )}
      >
        {resolvedCount} Resolved
        {activeTab === 'resolved' && (
          <div className="absolute -bottom-3 left-0 right-0 h-[2px] bg-gray-900" />
        )}
      </button>
    </div>
  );
};